/** NIVIO is light only. The type and helpers stay so persisted state and callers keep working. */
export type ThemeMode = 'light';

export function normalizeTheme(_value?: unknown): ThemeMode {
  return 'light';
}

export function applyTheme(_mode?: ThemeMode): void {
  const root = document.documentElement;
  root.dataset.theme = 'light';
  root.classList.remove('dark', 'dimmed');
  root.style.colorScheme = 'light';

  const themeColor = getComputedStyle(root).getPropertyValue('--theme-light').trim() || '#fefdf6';
  const metas = document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]');
  if (metas.length === 0) {
    const meta = document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = themeColor;
    document.head.append(meta);
    return;
  }
  metas.forEach((meta) => {
    meta.content = themeColor;
  });
}
